import React from 'react';
import { Sparkles, CheckCircle2, Phone, MessageCircle } from 'lucide-react';
import { NAIL_SERVICES, WHY_NAIL, whatsappLink, telLink } from '../data/content';

const NailStudio = () => {
  return (
    <div>
      {/* Hero */}
      <section className="relative min-h-[60vh] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1604654894610-df63bc536371?auto=format&fit=crop&w=1600&q=80"
            alt="Premium nail services"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 py-20">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-5">
              <Sparkles className="w-4 h-4 text-gold" />
              <span className="text-sm text-white tracking-wide">Premium Nail Services</span>
            </div>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05]">
              Nail <span className="text-gold-gradient">Studio</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl text-neutral-200 leading-relaxed">
              Experience the art of beautiful nails. From classic manicures to intricate nail art,
              we create stunning results that last.
            </p>
          </div>
        </div>
      </section>

      {/* Why choose our nail studio */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <span className="text-gold font-medium text-sm tracking-[0.25em] uppercase">Expert Care</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold mt-3 mb-5 text-neutral-900">
              Why Choose Our Nail Studio
            </h2>
            <div className="gold-divider mx-auto mb-6" />
            <p className="text-neutral-600">
              We specialize in nail care and artistry, offering premium services that stand out
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {WHY_NAIL.map((item) => (
              <div key={item.title} className="service-card bg-cream rounded-2xl p-7 text-center border border-gold/15">
                <div className="w-14 h-14 mx-auto rounded-full bg-gold flex items-center justify-center mb-4">
                  <CheckCircle2 className="w-7 h-7 text-white" strokeWidth={2} />
                </div>
                <h3 className="font-serif text-lg font-semibold text-neutral-900 leading-snug">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services list (no prices) */}
      <section className="py-20 md:py-24 bg-cream">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <span className="text-gold font-medium text-sm tracking-[0.25em] uppercase">Our Services</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold mt-3 mb-5 text-neutral-900">
              Nail Services
            </h2>
            <div className="gold-divider mx-auto" />
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            {NAIL_SERVICES.map((s) => (
              <div key={s.name} className="bg-white rounded-2xl p-6 border border-gold/15 shadow-sm btn-transition hover:border-gold">
                <h3 className="font-serif text-xl font-semibold text-neutral-900 mb-2">{s.name}</h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 bg-white border border-gold/20 rounded-2xl p-6 text-center">
            <p className="text-sm text-neutral-700 leading-relaxed">
              *Custom nail art designs available. Please call us for pricing based on the design
              complexity and your preferences.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gold to-gold-dark text-white">
        <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4">Want to Experience This Yourself?</h2>
          <p className="text-white/90 mb-8">Visit our salon and let us take care of your beauty needs</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={telLink} className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-gold-dark rounded-full font-semibold shadow-lg btn-transition hover:shadow-xl">
              <Phone className="w-5 h-5" /> Call to Book Now
            </a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-whatsapp text-white rounded-full font-semibold shadow-lg hover:bg-whatsapp-dark btn-transition">
              <MessageCircle className="w-5 h-5 fill-white" /> Message on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NailStudio;
